import React, { useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';
import { CheckIcon, CloseIcon, Edit1Icon, LoadingIcon } from 'tdesign-icons-react';
import { Button, Input, InputNumber, Space } from 'tdesign-react';
import DisableWrapper from '../DisableWrapper';

/**
 *
 * @param {Object} props
 * @param {string} props.text value值
 * @param {string} props.type 类型，默认text,支持number
 * @param {Object} props.inputProps input props
 * @param {CallableFunction} [props.onChange] 点击确定后修改回调
 * @returns
 */
export default function Editable({ text, onChange, type, inputProps }) {
  const [isEditing, setIsEditing] = useState(false);
  const [loading, setLoading] = useState(false);
  const [originText, setOriginText] = useState(text);
  const [value, setValue] = useState(text);

  useEffect(() => {
    setOriginText(text);
    setValue(text);
  }, [text]);

  const onSave = async () => {
    if (onChange) {
      setLoading(true);
      try {
        const result = await onChange(value);
        if (result !== false) {
          setIsEditing(false);
        }
      } catch (error) {
        console.trace(error);
        throw error;
      } finally {
        setLoading(false);
      }
    }
  };

  const doCancel = () => {
    setIsEditing(false);
    setValue(originText);
  };

  const input = useMemo(() => {
    if (type === 'number') {
      return (
        <InputNumber
          theme='normal'
          size='small'
          value={value}
          onChange={setValue}
          {...inputProps}
        />
      );
    }
    return <Input size='small' value={value} onChange={setValue} />;
  }, [type, value, inputProps]);

  return isEditing ? (
    <Root>
      {input}
      {loading ? (
        <LoadingIcon />
      ) : (
        <>
          <CheckIcon size={16} onClick={() => onSave(value)} style={{ cursor: 'pointer' }} />
          <CloseIcon size={16} onClick={doCancel} style={{ cursor: 'pointer' }} />
        </>
      )}
    </Root>
  ) : (
    <Space size={8}>
      {value}
      <DisableWrapper>
        <Button
          icon={<Edit1Icon />}
          theme='default'
          variant='text'
          size='small'
          onClick={() => setIsEditing(true)}
        />
      </DisableWrapper>
    </Space>
  );
}

const Root = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  max-width: 500px;
`;
